import { render, staticRenderFns } from "./assessment-auth.vue?vue&type=template&id=545376df&scoped=true"
import script from "./assessment-auth.vue?vue&type=script&lang=js"
export * from "./assessment-auth.vue?vue&type=script&lang=js"
import style0 from "./assessment-auth.vue?vue&type=style&index=0&id=545376df&prod&lang=css"
import style1 from "./assessment-auth.vue?vue&type=style&index=1&id=545376df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545376df",
  null
  
)

export default component.exports